import React from 'react';

const ConfirmationOverlay = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm mx-auto">
        <p className="text-lg font-semibold mb-4 text-green-800">{message}</p>
        <div className="flex justify-center space-x-4">
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 focus:outline-none"
          >
            Yes
          </button>
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 text-green-800 rounded hover:bg-gray-400 focus:outline-none"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationOverlay;


